import { useMemo, useState } from 'react';
import { GraphOptionItemProps } from '../types'
import { FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material'
import { getKeyColumns } from 'features/dashBoard/util';
import { getAxisTitle, KeyOfTargetListCategory } from 'features/search/targetList/util';

export const GraphOptionAxisItem = <T,>({
	option,
	options,
	configure,
  targetList,
	graphType,
	setOptionValue
}: GraphOptionItemProps<T>) => {
  const [open, setOpen] = useState(false)
  const columnList = useMemo(
    () => getKeyColumns(configure.axis, configure.category),
    [configure.axis, configure.category]
  )
  const value = useMemo(
    () => options.find((opt) => opt.id === option.id)?.value ?? (
      option.nullable ? '**' : option.default ?? Object.keys(configure.axis)[0] ?? '**'
    ),
    [options, option, configure]
  )
  return (
    <FormControl>
      <InputLabel id={`axis-${option.id}-label`}>{option.label}</InputLabel>
      <Select
        open={open}
        labelId={`axis-${option.id}-label`}
        label={option.label}
        id={`axis-${option.id}`}
        size="small"
        value={value}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        onChange={(event) => setOptionValue(option.id, event.target.value)}
        renderValue={(select) => {
          if (select=== "**") return "なし"
          if (select=== "@global") return "（ツールバーで選択）"
          return getAxisTitle(configure, select, targetList) ?? '不明'
        }}
      >
        { option.nullable && (
          <MenuItem key={`choice-empty`} value="**">
            なし
          </MenuItem>
        ) }

        <MenuItem key={`choice-global-axis`} value="@global">
          （ツールバーで選択）
        </MenuItem>

        {Object.keys(configure.axis).map((key, i) => (
          <MenuItem
            key={`hidden-axis-${key}-${i}`}
            value={key}
            style={{ display: "none" }}
          >
            {configure.axis[key].title}
          </MenuItem>
        ))}
        {targetList?.category?.map((category, i) => (
          <MenuItem
            key={`hidden-target-category-${i}`}
            value={`${KeyOfTargetListCategory}${category.sequence}`}
            style={{ display: "none" }}
          >
            {category.title}
          </MenuItem>
        ))}

        <Stack direction="row">
          {columnList.map((column, i) => (
            <Stack key={`axis-column-${i}`} direction="column">
              {column.category.map((category, j) => (
                <Stack key={`axis-category-${i}-${j}`} direction="column">
                  {category.title !== "" && (
                    <Typography variant='caption' component="div" paddingX={1} color="text.secondary" marginTop={1}>
                      {category.title}
                    </Typography>
                  )}
                  {category.keys.map((key, k) => {
                    const def = configure.axis[key]
                    if (graphType && def.validGraph && def.validGraph.indexOf(graphType) < 0) return <></>
                    return (
                      <MenuItem
                        key={`axis-${i}-${j}-${k}-${key}`}
                        selected={key === value}
                        onClick={() => {
                          setOptionValue(option.id, key)
                          setOpen(false)
                        }}
                      >
                        {def.title}
                      </MenuItem>
                    )
                  })}
                </Stack>
              ))}
            </Stack>
          ))}

          {targetList?.category && (
            <Stack key="axis-target-category" direction="column">
              {targetList.category.map((category, i) =>
                <MenuItem
                  key={`axis-taget-category-${i}-${category.sequence}`}
                  selected={value === `${KeyOfTargetListCategory}${category.sequence}`}
                  onClick={() => {
                    setOptionValue(option.id, `${KeyOfTargetListCategory}${category.sequence}`)
                    setOpen(false)
                  }}
                >
                  {category.title}
                </MenuItem>
              )}
            </Stack>
          )}
        </Stack>
      </Select>
    </FormControl>
  );
}
